/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './dashboard.component.css.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '../../../app/dashboard/dashboard.component';
import * as import3 from '../../../app/api/user.service';
import * as import4 from '../../../app/shared/router/linkhelper';
import * as import5 from '../../../app/shared/user-name.service';
import * as import6 from '@angular/router';
import * as import7 from '../../../app/shared/role-permission/role-permission';
const styles_DashboardComponent:any[] = [import0.styles];
export const RenderType_DashboardComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_DashboardComponent,
  data: {}
}
);
export function View_DashboardComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,([] as any[]),(null as any),(null as any));
}
function View_DashboardComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-dashboard',([] as any[]),(null as any),(null as any),(null as any),View_DashboardComponent_0,RenderType_DashboardComponent)),
    import1.ɵdid(245760,(null as any),0,import2.DashboardComponent,[
      import3.UserService,
      import4.LinkHelper,
      import5.UserNameService,
      import6.Router,
      import6.ActivatedRoute,
      import7.RolePermission
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const DashboardComponentNgFactory:import1.ComponentFactory<import2.DashboardComponent> = import1.ɵccf('app-dashboard',import2.DashboardComponent,View_DashboardComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9kYXNoYm9hcmQvZGFzaGJvYXJkLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92ZXJjZWwvd29ya3BhdGgwL3NyYy9hcHAvZGFzaGJvYXJkL2Rhc2hib2FyZC5jb21wb25lbnQudHMiLCJuZzovLy92ZXJjZWwvd29ya3BhdGgwL3NyYy9hcHAvZGFzaGJvYXJkL2Rhc2hib2FyZC5jb21wb25lbnQudHMuRGFzaGJvYXJkQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGFwcC1kYXNoYm9hcmQ+PC9hcHAtZGFzaGJvYXJkPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUNBQTtnQkFBQTs7Ozs7OztJQUFBO0tBQUE7OztJQUFBOzs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/dashboard/dashboard.component.ngfactory.ts